// Custom hook to manage dropdown state with the event bus
import { useEffect, useState } from 'react';
import { useDropdownsContext } from './dropdowns-context';
export const useDropdown = ({ id, calendarInstance, menuRef }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { dropdownOpenedEB } = useDropdownsContext();
    // Subscribe to the event bus
    useEffect(() => {
        const unsubscribe = dropdownOpenedEB.subscribe((openedId) => {
            // Close this dropdown if another one is opened
            if (openedId !== id && isOpen) {
                setIsOpen(false);
            }
        });
        // Cleanup subscription
        return () => unsubscribe();
    }, [dropdownOpenedEB, id, isOpen]);
    // Menu renders in the Portal, formally it's outside of calendar in terms of HTML
    // we want to prevent closing of calendar picker, when we are changing a month
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        let timeout;
        if (isOpen) {
            (_c = (_b = (_a = calendarInstance.current) === null || _a === void 0 ? void 0 : _a.calendar) === null || _b === void 0 ? void 0 : _b.disableOnClickOutside) === null || _c === void 0 ? void 0 : _c.call(_b);
            // scrollTo
            // [data-selected=true] still doesn't render, so setTimeout should be used
            timeout = setTimeout(() => {
                if (menuRef.current) {
                    const el = menuRef.current.querySelector('[data-selected=true]');
                    if (el) {
                        el.scrollIntoView({ behavior: 'instant', block: 'center' });
                    }
                }
            }, 0);
        }
        else {
            /* @ts-ignore */
            (_f = (_e = (_d = calendarInstance.current) === null || _d === void 0 ? void 0 : _d.calendar) === null || _e === void 0 ? void 0 : _e.enableOnClickOutside) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        return () => {
            var _a, _b, _c;
            clearTimeout(timeout);
            /* @ts-ignore */
            return (_c = (_b = (_a = calendarInstance === null || calendarInstance === void 0 ? void 0 : calendarInstance.current) === null || _a === void 0 ? void 0 : _a.calendar) === null || _b === void 0 ? void 0 : _b.enableOnClickOutside) === null || _c === void 0 ? void 0 : _c.call(_b);
        };
    }, [isOpen]);
    // Handlers
    const handleOpen = () => {
        setIsOpen(true);
        // Notify other dropdowns that this one is open
        dropdownOpenedEB.publish(id);
    };
    const handleToggle = () => {
        setIsOpen((state) => !state);
        dropdownOpenedEB.publish(id);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    return {
        isOpen,
        handleOpen,
        handleToggle,
        handleClose
    };
};
